export function publishing(storefront) {
  if (!storefront) {
    return false;
  }

  return storefront.async_progressing && storefront.async_type === 'publish';
}
